export const defaultRegisterFormState = {
  first_name: {
    rules: [
      { regexp: /^.+$/, error: 'Please fill out first name field' },
      { regexp: /^[A-Za-z]+[\w\-:.]*$/, error: 'Invalid first name' }
    ],
    valid: false,
    error: 'Please enter the first name'
  },
  last_name: {
    rules: [
      { regexp: /^.+$/, error: 'Please fill out last name field' },
      { regexp: /^[A-Za-z]+[\w\-:.]*$/, error: 'Invalid last name' }
    ],
    valid: false,
    error: 'Please enter the last name'
  },
  email: {
    rules: [
      { regexp: /^.+$/, error: 'Please fill out email field' },
      { regexp: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,8}$/, error: 'Invalid email' }
    ],
    valid: false,
    error: 'Please fill out email field'
  },
  password: {
    rules: [
      { regexp: /^.+$/, error: 'Please fill out password field' },
      { regexp: /^.{6,}$/, error: 'Password must be at least 6 characters long' }
    ],
    valid: false,
    error: 'Please fill out password field',
    equals: [
      { field: 'password_confirm', error: 'Passwords must match' }
    ]
  },
  password_confirm: {
    rules: [
      { regexp: /^.+$/, error: 'Please confirm password' }
    ],
    valid: false,
    error: 'Please confirm password'
  },
  /*how_did_you_hear_about_us: {
    rules: [
      { regexp: /^.+$/, error: 'This field is required' }
    ],
    valid: false,
    error: 'This field is required'
  },
  business_type: {
    rules: [
      { regexp: /^.+$/, error: 'This field is required' }
    ],
    valid: false,
    error: 'This field is required'
  },*/
  'g-recaptcha-response': {
    rules: [
      { regexp: /^.+$/, error: 'Please confirm you are not a robot' }
    ],
    valid: false,
    error: 'Please confirm you are not a robot'
  }
};
